import PortfolioPage from "./PortfolioPage";

export default function ClassVideosPage() {
  return (
    <PortfolioPage
      pageType="class-videos"
      title="Class Videos"
      subtitle="Watch our professional makeup training sessions and learn from the best"
    />
  );
}
